(() => {
  const drawer = document.getElementById('bsn-cart-drawer');
  if (!drawer) return;
  if (drawer.dataset.bsnDrawerInit === 'true') return;
  drawer.dataset.bsnDrawerInit = 'true';

  const panel = drawer.querySelector('.bsn-cart-drawer__panel');
  const body = drawer.querySelector('.bsn-cart-drawer__body');
  const itemsRoot = drawer.querySelector('[data-bsn-cart-items]');
  const subtotalEl = drawer.querySelector('[data-bsn-cart-subtotal]');
  const upsellRoot = drawer.querySelector('[data-bsn-upsell-root]');
  const upsellHeadlineEl = drawer.querySelector('[data-bsn-upsell-headline]');
  const upsellGrid = drawer.querySelector('[data-bsn-upsell-grid]');
  const buildsystemRoot = drawer.querySelector('[data-bsn-buildsystem-root]');
  const buildsystemDetailsEl = drawer.querySelector('[data-bsn-buildsystem-details]');
  const buildsystemCheckboxHeaderEl = drawer.querySelector('[data-bsn-buildsystem-checkbox-header]');
  const buildsystemToggleBtn = drawer.querySelector('[data-bsn-buildsystem-toggle]');
  const buildsystemToggleIconEl = drawer.querySelector('[data-bsn-buildsystem-toggle-icon]');
  const buildsystemNameLabelEl = drawer.querySelector('[data-bsn-buildsystem-name-label]');
  const buildsystemNotesLabelEl = drawer.querySelector('[data-bsn-buildsystem-notes-label]');
  const buildsystemNameInputEl = drawer.querySelector('[data-bsn-buildsystem-name]');
  const buildsystemNotesInputEl = drawer.querySelector('[data-bsn-buildsystem-notes]');
  const buildsystemCheckboxEl = drawer.querySelector('[data-bsn-buildsystem-checkbox]');
  const floatingCalloutFormRoot = drawer.querySelector('[data-bsn-floating-callout-form-root]');
  const floatingCalloutFormHeadingEl = drawer.querySelector('[data-bsn-floating-callout-form-heading]');
  const floatingCalloutFormMountEl = drawer.querySelector('[data-bsn-floating-callout-form-mount]');
  const floatingCalloutFormErrorEl = drawer.querySelector('[data-bsn-floating-callout-form-error]');
  const ctaRoot = drawer.querySelector('[data-bsn-cart-cta]'); // OPTIONAL mount for CTA
  const cartHeadingEl = drawer.querySelector('[data-bsn-cart-heading]');
  const subtotalLabelEl = drawer.querySelector('[data-bsn-subtotal-label]');
  const addToCartBtn = drawer.querySelector('#bsn-drawer-add-to-cart');
  const checkoutBtn = drawer.querySelector('#bsn-drawer-checkout');
  const checkoutTextEl = drawer.querySelector('.bsn-cart-drawer__checkout-text');
  const statusEl = drawer.querySelector('[data-bsn-cart-status]');

  let lastFocus = null;
  let focusables = [];
  let focusIndex = 0;

  const state = {
    lastAddedHandle: null,
    lastUpsellConfig: null, // { headline, upsells: [{handle, byline}, ...] }
    addedUpsellHandles: new Set(),
    productJsonCache: new Map(),
    productJsonInflight: new Map(),
    productBylineByLineKeyCache: new Map(),
    productBylineCache: new Map(),
    productBylineByIdCache: new Map(),
    lineTimers: new Map(),
    pendingLineQty: new Map(),
    lineRequestSeq: new Map(),
    refreshAbortController: null,
    refreshSeq: 0,
    pendingUpsellTriggerEl: null,
    drawerMode: 'default',
    floatingFormRenderKey: '',
    buildsystemCheckoutInFlight: false,
    buildsystemLastSubmitSig: '',
    buildsystemLastSubmitAt: 0,
    buildsystemBaseQtyByVariant: null,
    buildsystemBaselineInflight: null,
    _openingFromAdd: false // guard to prevent double-open from submit + fetch hook
  };

  const reportedDrawerFailures = new Set();
  const drawerRequestFailures = new WeakMap();

  // Preserve the original exception and keep request context out of customer/cart data.
  function rememberDrawerRequestFailure(error, details) {
    try {
      if (error && (typeof error === 'object' || typeof error === 'function')) {
        drawerRequestFailures.set(error, details);
      }
    } catch (_) {}
    return error;
  }

  function drawerErrorDetail(error, category, status) {
    if (category === 'http_error') return `http_${status || 'unknown'}`;
    if (category === 'response_parse_error') return 'invalid_cart_json';
    const message = error && typeof error.message === 'string' ? error.message : '';
    if (/^(Failed to fetch|Load failed|NetworkError when attempting to fetch resource\.?)$/i.test(message)) return 'network_fetch_failed';
    // Only recognize complete native error patterns; never forward arbitrary messages or stacks.
    const property = message.match(/^Cannot read properties of (null|undefined) \(reading '([A-Za-z_$][\w$]{0,39})'\)$/);
    if (property) return `${property[1]}_property:${property[2]}`;
    const method = message.match(/^([A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*){0,3}) is not a function$/);
    if (method) return `not_a_function:${method[1]}`.slice(0, 100);
    if (category === 'request_error') return 'request_rejected';
    return 'exception';
  }

  function reportDrawerFailure(operation, error, context = {}) {
    try {
      if (window.BSN_ERROR_TRACKING_ENABLED === false || (window.Shopify && window.Shopify.designMode)) return;
      if (reportedDrawerFailures.size >= 5 || reportedDrawerFailures.has(operation)) return;
      reportedDrawerFailures.add(operation);

      const script = document.querySelector('script[src*="bsn-cart-drawer.js"]');
      const main = document.querySelector('main[data-template]');
      const details = drawerRequestFailures.get(error) || context;
      const status = Number.isInteger(details.httpStatus) && details.httpStatus >= 100 && details.httpStatus <= 599 ? details.httpStatus : 0;
      const step = details.step || 'unknown';
      const category = details.httpFailure ? 'http_error'
        : /_parse$/.test(step) ? 'response_parse_error'
          : /_request$/.test(step) ? 'request_error' : 'javascript_error';
      const errorName = error && ['Error', 'TypeError', 'SyntaxError', 'ReferenceError', 'RangeError', 'URIError', 'EvalError', 'AbortError', 'NetworkError', 'SecurityError'].includes(error.name) ? error.name : '';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'bsn_js_error',
        page_path: window.location.pathname,
        page_type: main ? main.getAttribute('data-template') : '',
        error_type: 'handled_error',
        error_source: 'theme',
        error_message: `Cart drawer: ${operation} failed`,
        drawer_diagnostic: {
          version: 2,
          category,
          http_status: status,
          request_path: ['/cart.js', '/cart/add.js', '/cart/change.js'].includes(details.requestPath) ? details.requestPath : '',
          step,
          error_name: errorName,
          error_detail: drawerErrorDetail(error, category, status)
        },
        file_name: 'bsn-cart-drawer.js',
        file_url: script ? script.src.split('?')[0].split('#')[0] : '',
        resource_tag: '',
        line: 0,
        col: 0
      });
    } catch (_) {}
  }

  function resetBuildsystemBaseline() {
    state.buildsystemBaseQtyByVariant = null;
    state.buildsystemBaselineInflight = null;
  }

  function getBuildsystemMeasurementFlow() {
    const drawerContext = window.BSNCartDrawerContext && typeof window.BSNCartDrawerContext === 'object'
      ? window.BSNCartDrawerContext
      : {};
    const quizContext = window.BSNQuizMeasurementContext && typeof window.BSNQuizMeasurementContext === 'object'
      ? window.BSNQuizMeasurementContext
      : {};
    const quizVariant = String(
      drawerContext.measurementQuizVariant || quizContext.quiz_variant || ''
    ).trim();
    const sourceComponent = String(drawerContext.measurementSourceComponent || '').trim()
      || (quizVariant ? 'recommendation_quiz' : 'build_your_bundle');

    return {
      sourceComponent,
      quizVariant: quizVariant || null
    };
  }

  function getBuildsystemConfig() {
    const fallback = {
      showDownloadSummary: true,
      checkboxHeader: 'Checkbox Header',
      checkboxTooltip: 'Checkbox Tooltip',
      nameLabel: 'System Designed For',
      notesLabel: 'Additional Comments / Notes',
      namePlaceholder: 'Enter patient name (optional)',
      notesPlaceholder: 'Enter notes (optional)'
    };

    const fromCartSection =
      window.BSNBuildSystemDrawerConfig && typeof window.BSNBuildSystemDrawerConfig === 'object'
        ? window.BSNBuildSystemDrawerConfig
        : {};

    return Object.assign({}, fallback, fromCartSection);
  }

  function applyDrawerContextFromWindow() {
    const prevMode = state.drawerMode;
    const ctx = window.BSNCartDrawerContext;
    if (!ctx || typeof ctx !== 'object') return;
    if (ctx.mode === 'buildsystem') state.drawerMode = 'buildsystem';
    else if (ctx.mode === 'floating_callout') state.drawerMode = 'floating_callout';
    else state.drawerMode = 'default';
    if (prevMode !== state.drawerMode) {
      resetBuildsystemBaseline();
      state.floatingFormRenderKey = '';
    }
  }

  function setDefaultDrawerContext() {
    window.BSNCartDrawerContext = { mode: 'default' };
    state.drawerMode = 'default';
    resetBuildsystemBaseline();
  }

  function ensureBuildsystemStateStore() {
    if (!window.BSNCartDrawerBuildsystemState || typeof window.BSNCartDrawerBuildsystemState !== 'object') {
      window.BSNCartDrawerBuildsystemState = { checkboxChecked: false, detailsCollapsed: false, name: '', notes: '' };
    }
    return window.BSNCartDrawerBuildsystemState;
  }

  function getFloatingCalloutFormConfig() {
    const drawerContext = window.BSNCartDrawerContext && typeof window.BSNCartDrawerContext === 'object'
      ? window.BSNCartDrawerContext
      : {};
    const contextConfig = drawerContext.formConfig && typeof drawerContext.formConfig === 'object'
      ? drawerContext.formConfig
      : null;
    const cfg = contextConfig || window.BSNFloatingCalloutDrawerConfig;
    if (!cfg || typeof cfg !== 'object') return {};
    return {
      portalId: String(cfg.portalId || '').trim(),
      formId: String(cfg.formId || '').trim(),
      region: String(cfg.region || 'na1').trim()
    };
  }

  function showFloatingFormError(message) {
    if (!floatingCalloutFormErrorEl) return;
    const text = String(message || '').trim();
    floatingCalloutFormErrorEl.hidden = !text;
    floatingCalloutFormErrorEl.textContent = text;
  }

  function loadHubSpotFormScript() {
    return new Promise((resolve, reject) => {
      if (window.hbspt && window.hbspt.forms && typeof window.hbspt.forms.create === 'function') {
        resolve(window.hbspt);
        return;
      }

      const existing = document.querySelector('script[data-bsn-hubspot-forms]');
      if (existing) {
        existing.addEventListener('load', () => resolve(window.hbspt), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/embed/v2.js';
      script.async = true;
      script.defer = true;
      script.setAttribute('data-bsn-hubspot-forms', 'true');
      script.addEventListener('load', () => resolve(window.hbspt), { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
  }

  async function renderFloatingCalloutForm() {
    if (!floatingCalloutFormMountEl) return;
    const cfg = getFloatingCalloutFormConfig();
    const renderKey = `${cfg.portalId}|${cfg.formId}|${cfg.region}`;
    if (state.floatingFormRenderKey === renderKey && floatingCalloutFormMountEl.childElementCount > 0) {
      return;
    }

    floatingCalloutFormMountEl.innerHTML = '';
    showFloatingFormError('');

    if (!cfg.portalId || !cfg.formId) {
      showFloatingFormError('HubSpot form is not configured.');
      state.floatingFormRenderKey = '';
      return;
    }

    const targetId = `bsn-hubspot-form-${cfg.portalId}-${cfg.formId}`.replace(/[^a-zA-Z0-9_-]/g, '-');
    floatingCalloutFormMountEl.innerHTML = `<div id="${targetId}"></div>`;

    try {
      await loadHubSpotFormScript();
      if (!window.hbspt || !window.hbspt.forms || typeof window.hbspt.forms.create !== 'function') {
        throw new Error('HubSpot forms API unavailable');
      }
      window.hbspt.forms.create({
        region: cfg.region || 'na1',
        portalId: cfg.portalId,
        formId: cfg.formId,
        target: `#${targetId}`
      });
      state.floatingFormRenderKey = renderKey;
    } catch (error) {
      showFloatingFormError('Unable to load HubSpot form.');
      state.floatingFormRenderKey = '';
    }
  }

  function prewarmFloatingCalloutFormOnFirstScroll() {
    const cfg = getFloatingCalloutFormConfig();
    if (!cfg.portalId || !cfg.formId) return;
    let hasPrewarmed = false;
    const onFirstScroll = () => {
      if (hasPrewarmed) return;
      hasPrewarmed = true;
      window.removeEventListener('scroll', onFirstScroll);
      renderFloatingCalloutForm().catch(() => {});
    };
    window.addEventListener('scroll', onFirstScroll, { passive: true });
  }

  function renderBuildsystemExtras() {
    if (!buildsystemRoot) return;

    const isBuildsystem = state.drawerMode === 'buildsystem';
    const isFloatingCalloutForm = state.drawerMode === 'floating_callout';
    const cfg = getBuildsystemConfig();
    const showDownloadSummary = cfg.showDownloadSummary !== false;
    buildsystemRoot.hidden = !isBuildsystem || !showDownloadSummary;
    if (floatingCalloutFormRoot) floatingCalloutFormRoot.hidden = !isFloatingCalloutForm;
    drawer.classList.toggle('has-buildsystem', isBuildsystem && showDownloadSummary);
    drawer.classList.toggle('has-floating-callout-form', isFloatingCalloutForm);
    if (isBuildsystem && upsellRoot) {
      upsellRoot.hidden = true;
      drawer.classList.remove('has-upsells');
    }
    if (isFloatingCalloutForm && upsellRoot) {
      upsellRoot.hidden = true;
      drawer.classList.remove('has-upsells');
    }
    if (checkoutTextEl) {
      checkoutTextEl.textContent = isBuildsystem ? 'Add and checkout' : 'Checkout';
    }
    if (cartHeadingEl) {
      if (isBuildsystem) {
        cartHeadingEl.textContent = 'Your System:';
      } else if (isFloatingCalloutForm) {
        cartHeadingEl.textContent = '';
      } else {
        cartHeadingEl.textContent = 'Your Cart:';
      }
    }
    if (subtotalLabelEl) {
      subtotalLabelEl.textContent = isBuildsystem ? 'System Subtotal:' : 'Subtotal';
    }
    if (isFloatingCalloutForm) {
      if (floatingCalloutFormHeadingEl) {
        floatingCalloutFormHeadingEl.textContent = '';
      }
      renderFloatingCalloutForm();
      drawer.classList.remove('buildsystem-details-open');
      if (buildsystemDetailsEl) buildsystemDetailsEl.hidden = true;
      return;
    }
    if (!isBuildsystem) {
      drawer.classList.remove('buildsystem-details-open');
      if (buildsystemDetailsEl) buildsystemDetailsEl.hidden = true;
      return;
    }

    const store = ensureBuildsystemStateStore();
    if (!showDownloadSummary) store.checkboxChecked = false;

    if (buildsystemCheckboxHeaderEl) buildsystemCheckboxHeaderEl.textContent = String(cfg.checkboxHeader || '').trim();
    if (buildsystemCheckboxHeaderEl) buildsystemCheckboxHeaderEl.setAttribute('data-tip', String(cfg.checkboxTooltip || '').trim());
    if (buildsystemNameLabelEl) buildsystemNameLabelEl.textContent = String(cfg.nameLabel || '').trim();
    if (buildsystemNotesLabelEl) buildsystemNotesLabelEl.textContent = String(cfg.notesLabel || '').trim();
    if (buildsystemNameInputEl) buildsystemNameInputEl.placeholder = String(cfg.namePlaceholder || '').trim();
    if (buildsystemNotesInputEl) buildsystemNotesInputEl.placeholder = String(cfg.notesPlaceholder || '').trim();

    if (buildsystemCheckboxEl) buildsystemCheckboxEl.checked = !!store.checkboxChecked;
    const detailsVisible = !!store.checkboxChecked && !store.detailsCollapsed;
    if (buildsystemDetailsEl) buildsystemDetailsEl.hidden = !detailsVisible;
    drawer.classList.toggle('buildsystem-details-open', !!store.checkboxChecked);
    if (buildsystemToggleBtn) buildsystemToggleBtn.hidden = !store.checkboxChecked;
    if (buildsystemToggleIconEl) buildsystemToggleIconEl.textContent = detailsVisible ? '▾' : '▴';
    if (buildsystemToggleBtn) {
      buildsystemToggleBtn.setAttribute('aria-label', detailsVisible ? 'Collapse details' : 'Expand details');
    }
    if (buildsystemNameInputEl) buildsystemNameInputEl.value = String(store.name || '');
    if (buildsystemNotesInputEl) buildsystemNotesInputEl.value = String(store.notes || '');
  }

  function formatMoney(cents) {
    const dollars = (Number(cents || 0) / 100).toFixed(2);
    return `$${dollars}`;
  }

  function lockScroll() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bsn-cart-drawer-open');
    lockScroll();
    refreshFocusables();
    requestAnimationFrame(() => {
      if (body && typeof body.focus === 'function') body.focus({ preventScroll: true });
    });
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.classList.remove('has-buildsystem');
    drawer.classList.remove('has-floating-callout-form');
    drawer.classList.remove('buildsystem-details-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bsn-cart-drawer-open');
    unlockScroll();
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function refreshFocusables() {
    if (!panel) return;
    focusables = panel.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    focusables = Array.from(focusables);
    focusIndex = Math.max(0, focusables.indexOf(document.activeElement));
  }

  function trapFocus(e) {
    if (!drawer.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if (e.key !== 'Tab') return;

    refreshFocusables();
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // Close: X + backdrop click
  drawer.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[data-bsn-drawer-close]');
    if (closeBtn) closeDrawer();
    if (e.target === drawer) closeDrawer();
  });

  document.addEventListener('keydown', trapFocus);

  function setBuildsystemActionLoading(isLoading) {
    const disabled = !!isLoading;
    if (checkoutBtn) {
      if (disabled) {
        checkoutBtn.setAttribute('aria-disabled', 'true');
        checkoutBtn.classList.add('is-loading');
      } else {
        checkoutBtn.removeAttribute('aria-disabled');
        checkoutBtn.classList.remove('is-loading');
      }
    }
    if (addToCartBtn) {
      if (disabled) {
        addToCartBtn.setAttribute('aria-disabled', 'true');
        addToCartBtn.classList.add('is-loading');
      } else {
        addToCartBtn.removeAttribute('aria-disabled');
        addToCartBtn.classList.remove('is-loading');
      }
    }
  }

  async function runBuildsystemSubmitFlow(redirectTo) {
    if (state.buildsystemCheckoutInFlight) return;
    state.buildsystemCheckoutInFlight = true;
    setBuildsystemActionLoading(true);

    try {
      const selected = collectBuildsystemSelections();
      if (!selected.length) {
        setStatus('Select at least one item to continue.', 'error');
        state.buildsystemCheckoutInFlight = false;
        setBuildsystemActionLoading(false);
        return;
      }

      await ensureBuildsystemBaseline();

      setStatus(redirectTo === '/checkout' ? 'Preparing checkout...' : 'Adding to cart...');
      const store = ensureBuildsystemStateStore();
      if (store && store.checkboxChecked && window.BSN_Cart && typeof window.BSN_Cart.generateAndDownloadPdf === 'function') {
        await window.BSN_Cart.generateAndDownloadPdf(store.name || '', store.notes || '');
      }
      await syncBuildsystemSelectionsAndRedirect(redirectTo);
    } catch (err) {
      setStatus('Could not complete this action. Please try again.', 'error');
      state.buildsystemLastSubmitSig = '';
      state.buildsystemLastSubmitAt = 0;
      window.__BSN_BUILD_CHECKOUT_LOCK = { sig: '', at: 0 };
      state.buildsystemCheckoutInFlight = false;
      setBuildsystemActionLoading(false);
    }
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      if (state.drawerMode === 'buildsystem') {
        await runBuildsystemSubmitFlow('/cart');
        return;
      }
      window.location.href = '/cart';
    });
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      if (state.drawerMode === 'buildsystem') {
        await runBuildsystemSubmitFlow('/checkout');
        return;
      }

      window.location.href = '/checkout';
    });
  }

  if (buildsystemCheckboxEl) {
    buildsystemCheckboxEl.addEventListener('change', () => {
      const store = ensureBuildsystemStateStore();
      store.checkboxChecked = !!buildsystemCheckboxEl.checked;
      if (!store.checkboxChecked) {
        store.detailsCollapsed = false;
      }
      const detailsVisible = !!store.checkboxChecked && !store.detailsCollapsed;
      if (buildsystemDetailsEl) buildsystemDetailsEl.hidden = !detailsVisible;
      drawer.classList.toggle('buildsystem-details-open', !!store.checkboxChecked);
      if (buildsystemToggleBtn) buildsystemToggleBtn.hidden = !store.checkboxChecked;
      if (buildsystemToggleIconEl) buildsystemToggleIconEl.textContent = detailsVisible ? '▾' : '▴';
      if (buildsystemToggleBtn) {
        buildsystemToggleBtn.setAttribute('aria-label', detailsVisible ? 'Collapse details' : 'Expand details');
      }
      if (detailsVisible && body) {
        requestAnimationFrame(() => {
          body.scrollTo({ top: body.scrollHeight, behavior: 'smooth' });
        });
      }
    });
  }

  if (buildsystemToggleBtn) {
    buildsystemToggleBtn.addEventListener('click', () => {
      const store = ensureBuildsystemStateStore();
      if (!store.checkboxChecked) return;
      store.detailsCollapsed = !store.detailsCollapsed;
      const detailsVisible = !store.detailsCollapsed;
      if (buildsystemDetailsEl) buildsystemDetailsEl.hidden = !detailsVisible;
      if (buildsystemToggleIconEl) buildsystemToggleIconEl.textContent = detailsVisible ? '▾' : '▴';
      buildsystemToggleBtn.setAttribute('aria-label', detailsVisible ? 'Collapse details' : 'Expand details');
      if (detailsVisible && body) {
        requestAnimationFrame(() => {
          body.scrollTo({ top: body.scrollHeight, behavior: 'smooth' });
        });
      }
    });
  }

  if (buildsystemNameInputEl) {
    buildsystemNameInputEl.addEventListener('input', () => {
      const store = ensureBuildsystemStateStore();
      store.name = buildsystemNameInputEl.value || '';
    });
  }

  if (buildsystemNotesInputEl) {
    buildsystemNotesInputEl.addEventListener('input', () => {
      const store = ensureBuildsystemStateStore();
      store.notes = buildsystemNotesInputEl.value || '';
    });
  }

  function isAbortError(error) {
    return error && (error.name === 'AbortError' || String(error.message || '').toLowerCase().includes('aborted'));
  }

  function setLoadingState(isLoading) {
    drawer.classList.toggle('is-loading', !!isLoading);
  }

  function setStatus(message = '', type = '') {
    if (!statusEl) return;
    const normalized = String(message || '').trim();
    if (!normalized) {
      statusEl.hidden = true;
      statusEl.textContent = '';
      statusEl.removeAttribute('data-status-type');
      return;
    }
    statusEl.hidden = false;
    statusEl.textContent = normalized;
    if (type) {
      statusEl.setAttribute('data-status-type', type);
    } else {
      statusEl.removeAttribute('data-status-type');
    }
  }

  function toSizedShopifyImage(url, width) {
    const src = String(url || '').trim();
    if (!src || !width) return src;
    if (!src.includes('cdn.shopify.com')) return src;
    const separator = src.includes('?') ? '&' : '?';
    return `${src}${separator}width=${Number(width)}`;
  }

  function parseMoneyToCents(text) {
    const raw = String(text || '').trim();
    if (!raw) return 0;
    const numeric = raw.replace(/[^\d.,]/g, '').replace(/,/g, '');
    if (!numeric) return 0;
    const parsed = Number.parseFloat(numeric);
    if (!Number.isFinite(parsed)) return 0;
    return Math.round(parsed * 100);
  }

  function cleanOneLine(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function cleanCardHeadingText(card, fallback = 'Item') {
    const titleNode = card ? card.querySelector('.card__content h3') : null;
    if (!titleNode) return fallback;

    const clone = titleNode.cloneNode(true);
    clone.querySelectorAll('.bsn-tip, .bsn-tooltip, .bsn-tip__trigger').forEach((el) => {
      el.remove();
    });

    return cleanOneLine(clone.textContent) || fallback;
  }

  function collectBuildsystemSelections() {
    const cards = Array.from(document.querySelectorAll('.buildsystem-product__card'));
    return cards.map((card) => {
      const qtyInput = card.querySelector('input[id^="qty-"]');
      const qty = Math.max(0, Number.parseInt(qtyInput && qtyInput.value ? qtyInput.value : '0', 10) || 0);
      if (!qty) return null;

      const variantId = String(card.getAttribute('data-variant-id') || '').trim();
      const handle = String(card.getAttribute('data-product-handle') || '').trim();
      const titleAttr = String(card.getAttribute('data-printout-description') || '').trim();
      const titleText = cleanCardHeadingText(card, '');
      const title = titleAttr || titleText || 'Item';
      const bylineAttr = String(card.getAttribute('data-bsn-shortest-byline') || '').trim();
      const bylineNode = card.querySelector('.card__content .rte.small');
      const bylineFallback = bylineNode ? cleanOneLine(bylineNode.textContent) : '';
      const byline = bylineAttr || bylineFallback;
      const priceNode = card.querySelector('[data-price]');
      const unitPriceCents = parseMoneyToCents(priceNode ? priceNode.textContent : '');
      const imgNode = card.querySelector('.card__media img');
      const image = imgNode ? String(imgNode.getAttribute('src') || '').trim() : '';
      const productUrl = handle ? `/products/${handle}` : '#';

      return {
        variantId,
        key: `buildsystem:${variantId || handle || title}`,
        handle,
        product_title: title,
        quantity: qty,
        unit_price_cents: unitPriceCents,
        final_line_price: unitPriceCents * qty,
        original_line_price: unitPriceCents * qty,
        image,
        url: productUrl,
        byline
      };
    }).filter(Boolean);
  }

  function setBuildsystemCardQty(variantId, nextQty) {
    if (!variantId || !window.CSS || typeof window.CSS.escape !== 'function') return;
    const card = document.querySelector(`.buildsystem-product__card[data-variant-id="${window.CSS.escape(String(variantId))}"]`);
    if (!card) return;
    const qtyInput = card.querySelector('input[id^="qty-"]');
    if (!qtyInput) return;

    const qty = Math.max(0, Math.min(99, Number.parseInt(String(nextQty), 10) || 0));
    qtyInput.value = String(qty);
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function buildBuildsystemPreviewCartPayload() {
    const items = collectBuildsystemSelections();
    const subtotal = items.reduce((sum, item) => sum + Number(item.final_line_price || 0), 0);
    return { items, items_subtotal_price: subtotal };
  }

  async function ensureBuildsystemBaseline() {
    if (state.buildsystemBaseQtyByVariant instanceof Map) return state.buildsystemBaseQtyByVariant;
    if (state.buildsystemBaselineInflight) return await state.buildsystemBaselineInflight;

    state.buildsystemBaselineInflight = (async () => {
      const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!cartRes.ok) throw new Error('Failed to read cart before sync');
      const cart = await cartRes.json();
      const baseline = new Map();
      (cart.items || []).forEach((line) => {
        const id = Number(line && line.variant_id);
        const qty = Math.max(0, Number(line && line.quantity) || 0);
        if (!Number.isFinite(id)) return;
        baseline.set(id, (baseline.get(id) || 0) + qty);
      });
      state.buildsystemBaseQtyByVariant = baseline;
      return baseline;
    })();

    try {
      return await state.buildsystemBaselineInflight;
    } finally {
      state.buildsystemBaselineInflight = null;
    }
  }

  async function syncBuildsystemSelectionsAndRedirect(redirectTo) {
    const qtyByVariant = new Map();
    collectBuildsystemSelections().forEach((item) => {
      const id = Number(item.variantId);
      const qty = Math.max(0, Number(item.quantity) || 0);
      if (!Number.isFinite(id)) return;
      qtyByVariant.set(id, (qtyByVariant.get(id) || 0) + qty);
    });

    const selectedItems = Array.from(qtyByVariant.entries())
      .map(([id, quantity]) => ({ id, quantity }))
      .sort((a, b) => a.id - b.id);
    if (!selectedItems.length) return;

    // Lock should represent user intent (selection + action), not current cart state.
    const intentSig = `${String(redirectTo || '')}|${JSON.stringify(selectedItems)}`;
    const now = Date.now();
    const globalLock = window.__BSN_BUILD_CHECKOUT_LOCK || { sig: '', at: 0 };
    if (globalLock.sig === intentSig && now - globalLock.at < 8000) return;
    window.__BSN_BUILD_CHECKOUT_LOCK = { sig: intentSig, at: now };

    if (state.buildsystemLastSubmitSig === intentSig && now - state.buildsystemLastSubmitAt < 5000) return;
    state.buildsystemLastSubmitSig = intentSig;
    state.buildsystemLastSubmitAt = now;

    // Merge selected build quantities into the baseline cart captured for this drawer session.
    const baseline = await ensureBuildsystemBaseline();
    const updates = {};
    selectedItems.forEach(({ id, quantity }) => {
      updates[id] = (baseline.get(id) || 0) + quantity;
    });

    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!res.ok) throw new Error('Failed to sync build system items');
    if (window.BSNMeasurement) {
      const measurementFlow = getBuildsystemMeasurementFlow();
      window.BSNMeasurement.toolEvent('tool_submit', measurementFlow.sourceComponent, {
        interaction_location: 'system_drawer',
        display_mode: 'drawer',
        destination_type: redirectTo === '/cart' ? 'cart' : 'checkout',
        item_count: selectedItems.reduce((sum, item) => sum + item.quantity, 0),
        quiz_variant: measurementFlow.quizVariant
      });
    }
    window.location.href = redirectTo || '/checkout';
  }

  function hasDrawerUpsellHeader(init = {}) {
    const headers = init && init.headers;
    if (!headers) return false;
    if (headers instanceof Headers) {
      return headers.get('X-BSN-Drawer-Upsell') === '1';
    }
    if (Array.isArray(headers)) {
      return headers.some((entry) => Array.isArray(entry) && String(entry[0]).toLowerCase() === 'x-bsn-drawer-upsell' && String(entry[1]) === '1');
    }
    if (typeof headers === 'object') {
      return String(headers['X-BSN-Drawer-Upsell'] || headers['x-bsn-drawer-upsell'] || '') === '1';
    }
    return false;
  }

  async function getCart(signal) {
    const diagnostic = { requestPath: '/cart.js', step: 'cart_request', httpStatus: 0 };
    try {
      const res = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        signal
      });
      diagnostic.httpStatus = res.status;
      diagnostic.step = 'cart_response';
      if (!res.ok) {
        diagnostic.httpFailure = true;
        throw new Error('Failed to fetch cart');
      }
      diagnostic.step = 'cart_parse';
      return await res.json();
    } catch (error) {
      throw rememberDrawerRequestFailure(error, diagnostic);
    }
  }

  async function changeLine(key, quantity) {
    const diagnostic = { requestPath: '/cart/change.js', step: 'quantity_request', httpStatus: 0 };
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      diagnostic.httpStatus = res.status;
      diagnostic.step = 'quantity_response';
      if (!res.ok) {
        diagnostic.httpFailure = true;
        throw new Error('Failed to change cart');
      }
      diagnostic.step = 'quantity_parse';
      return await res.json();
    } catch (error) {
      throw rememberDrawerRequestFailure(error, diagnostic);
    }
  }

  function renderPrimaryCTA() {
    if (!ctaRoot) return;

    // Theme button pattern: <a class="button bg-primary mt-sm">
    ctaRoot.innerHTML = `
      <a href="/cart" class="button bg-primary mt-sm" data-bsn-go-to-cart>
        Go to cart
      </a>
    `;
  }

  async function syncDrawerFromCart(cart, options = {}) {
    await renderCart(cart);
    if (!options.skipUpsells) {
      await renderUpsells(cart);
    }
    renderBuildsystemExtras();
    refreshFocusables();
  }

  function scheduleLineQuantityCommit(lineKey, nextQty) {
    if (!lineKey) return;
    state.pendingLineQty.set(lineKey, nextQty);

    if (state.lineTimers.has(lineKey)) {
      clearTimeout(state.lineTimers.get(lineKey));
    }

    const timer = setTimeout(async () => {
      const qtyToCommit = state.pendingLineQty.get(lineKey);
      state.lineTimers.delete(lineKey);
      state.pendingLineQty.delete(lineKey);
      await commitLineQuantityNow(lineKey, qtyToCommit);
    }, 110);

    state.lineTimers.set(lineKey, timer);
  }

  async function commitLineQuantityNow(lineKey, nextQty) {
    if (!lineKey) return;

    if (state.lineTimers.has(lineKey)) {
      clearTimeout(state.lineTimers.get(lineKey));
      state.lineTimers.delete(lineKey);
    }
    state.pendingLineQty.delete(lineKey);

    const seq = (state.lineRequestSeq.get(lineKey) || 0) + 1;
    state.lineRequestSeq.set(lineKey, seq);

    try {
      const cart = await changeLine(lineKey, nextQty);
      if (state.lineRequestSeq.get(lineKey) !== seq) return;
      await syncDrawerFromCart(cart);
    } catch (e) {
      if (state.lineRequestSeq.get(lineKey) !== seq) return;
      reportDrawerFailure('cart_quantity_update', e, { step: 'sync_drawer' });
      // Recover visual state from server on failure.
      await refreshDrawer();
    }
  }

  async function renderCart(cart) {
    if (!itemsRoot) return;
    itemsRoot.innerHTML = '';
    const isBuildsystemPreview = state.drawerMode === 'buildsystem';

    const rows = await Promise.all((cart.items || []).map(async (item) => {
      const linePrice = item.final_line_price;
      const compareLine = item.original_line_price;
      const hasDiscount = Number(compareLine) > Number(linePrice);
      const bylineMeta = await getProductShortByline(item);
      const byline = bylineMeta || (isBuildsystemPreview ? String(item.byline || '').trim() : '');

      const row = document.createElement('div');
      row.className = 'bsn-cart-row';
      row.dataset.key = item.key;

      const imgUrl = item.image ? item.image.replace(/(\.[a-zA-Z]+)$/, '_150x$1') : '';
      const productUrl = item.url || `/products/${item.handle}`;

      row.innerHTML = `
        <a class="bsn-cart-row__img" href="${productUrl}" aria-label="${item.product_title}">
          ${imgUrl ? `<img src="${imgUrl}" alt="${item.product_title}">` : ''}
        </a>

        <div class="bsn-cart-row__content">
          <div class="bsn-cart-row__head">
            <div class="bsn-cart-row__head-main">
              <div class="bsn-cart-row__title-wrap">
                <a class="bsn-cart-row__title" href="${productUrl}">
                  <p><strong>${item.product_title}</strong></p>
                </a>
              </div>
              ${byline ? `<p class="bsn-cart-row__byline">${byline}</p>` : ''}
            </div>
            <div class="bsn-cart-row__price-col">
              <div class="bsn-cart-row__price">${formatMoney(linePrice)}</div>
              <div class="bsn-cart-row__meta">
                <div class="quantity bsn-qty" data-bsn-line-key="${item.key}">
                  <button class="quantity__button" name="minus" type="button" data-action="minus" aria-label="Decrease quantity">
                    <span aria-hidden="true">−</span>
                  </button>
                  <input
                    class="quantity__input"
                    type="number"
                    value="${item.quantity}"
                    min="0"
                    step="1"
                    aria-label="Quantity"
                  >
                  <button class="quantity__button" name="plus" type="button" data-action="plus" aria-label="Increase quantity">
                    <span aria-hidden="true">+</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          ${hasDiscount ? `<div class="bsn-line-note"><p>Was ${formatMoney(compareLine)}</p></div>` : ''}
        </div>
      `;

      const qtyInput = row.querySelector('.quantity__input');
      const getCurrentQty = () => Math.max(0, Number.parseInt(qtyInput.value, 10) || 0);

      row.querySelector('[data-action="minus"]').addEventListener('click', () => {
        const nextQty = Math.max(0, getCurrentQty() - 1);
        qtyInput.value = String(nextQty); // Optimistic UI
        if (isBuildsystemPreview) {
          setBuildsystemCardQty(item.variantId, nextQty);
          refreshDrawer({ silent: true });
        } else {
          scheduleLineQuantityCommit(item.key, nextQty);
        }
      });

      row.querySelector('[data-action="plus"]').addEventListener('click', () => {
        const nextQty = getCurrentQty() + 1;
        qtyInput.value = String(nextQty); // Optimistic UI
        if (isBuildsystemPreview) {
          setBuildsystemCardQty(item.variantId, nextQty);
          refreshDrawer({ silent: true });
        } else {
          scheduleLineQuantityCommit(item.key, nextQty);
        }
      });

      const commitTypedQuantity = async () => {
        const nextQty = Math.max(0, Number.parseInt(qtyInput.value, 10) || 0);
        qtyInput.value = String(nextQty);
        if (isBuildsystemPreview) {
          setBuildsystemCardQty(item.variantId, nextQty);
          await refreshDrawer({ silent: true });
          return;
        }
        await commitLineQuantityNow(item.key, nextQty);
      };

      qtyInput.addEventListener('change', async () => {
        await commitTypedQuantity();
      });

      qtyInput.addEventListener('keydown', async (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        await commitTypedQuantity();
      });

      return row;
    }));

    rows.forEach((row) => itemsRoot.appendChild(row));

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);

    renderPrimaryCTA();
  }

  async function getProductJson(handle) {
    if (!handle) throw new Error('Missing product handle');
    if (state.productJsonCache.has(handle)) return state.productJsonCache.get(handle);
    if (state.productJsonInflight.has(handle)) return state.productJsonInflight.get(handle);

    const inflight = (async () => {
      const res = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('Failed to fetch product JSON');
      const product = await res.json();
      state.productJsonCache.set(handle, product);
      return product;
    })();

    state.productJsonInflight.set(handle, inflight);
    try {
      return await inflight;
    } finally {
      state.productJsonInflight.delete(handle);
    }
  }

  async function getProductShortByline(item) {
    const lineKey = item && item.key ? String(item.key) : '';
    const productId = item && item.product_id ? String(item.product_id) : '';
    const handle = item && item.handle ? String(item.handle) : '';

    if (lineKey && state.productBylineByLineKeyCache.has(lineKey)) return state.productBylineByLineKeyCache.get(lineKey);
    if (productId && state.productBylineByIdCache.has(productId)) return state.productBylineByIdCache.get(productId);
    if (handle && state.productBylineCache.has(handle)) return state.productBylineCache.get(handle);
    if (!handle) return '';

    try {
      const product = await getProductJson(handle);
      const byline = String(product?.metafields?.custom?.bsn_shortest_byline_1 || '').trim();
      if (lineKey) state.productBylineByLineKeyCache.set(lineKey, byline);
      if (productId) state.productBylineByIdCache.set(productId, byline);
      state.productBylineCache.set(handle, byline);
      return byline;
    } catch (e) {
      if (lineKey) state.productBylineByLineKeyCache.set(lineKey, '');
      if (productId) state.productBylineByIdCache.set(productId, '');
      state.productBylineCache.set(handle, '');
      return '';
    }
  }

  async function hydrateBylineCacheFromLiquid(signal) {
    try {
      const res = await fetch(`/?section_id=bsn-cart-byline-map&_=${Date.now()}`, { signal });
      if (!res.ok) return;

      const html = await res.text();
      if (!html) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const script = doc.querySelector('[data-bsn-cart-bylines-json]');
      if (!script) return;

      const bylines = JSON.parse(script.textContent || '[]');
      if (!Array.isArray(bylines)) return;

      bylines.forEach((entry) => {
        if (!entry) return;
        const normalizedByline = String(entry.byline || '').trim();
        if (entry.key) {
          state.productBylineByLineKeyCache.set(String(entry.key), normalizedByline);
        }
        if (entry.product_id != null && entry.product_id !== '') {
          state.productBylineByIdCache.set(String(entry.product_id), normalizedByline);
        }
        if (entry.handle) {
          state.productBylineCache.set(String(entry.handle), normalizedByline);
        }
      });
    } catch (e) {
      if (isAbortError(e)) return;
      // no-op; fallback path remains getProductJson()
    }
  }

  function readUpsellConfigFromTrigger(triggerEl) {
    if (!triggerEl || typeof triggerEl.closest !== 'function') return null;

    const form = triggerEl.closest('form');
    const selfScript = triggerEl.matches && triggerEl.matches('script[data-bsn-upsell-json]') ? triggerEl : null;
    const siblingScript =
      (form && form.nextElementSibling && form.nextElementSibling.matches && form.nextElementSibling.matches('script[data-bsn-upsell-json]') && form.nextElementSibling) ||
      (form && form.previousElementSibling && form.previousElementSibling.matches && form.previousElementSibling.matches('script[data-bsn-upsell-json]') && form.previousElementSibling) ||
      null;
    const scopedContainer = triggerEl.closest('[data-bsn-upsell-scope]') || triggerEl.parentElement;

    const candidates = [
      selfScript,
      form ? form.querySelector('script[data-bsn-upsell-json]') : null,
      siblingScript,
      scopedContainer ? scopedContainer.querySelector('script[data-bsn-upsell-json]') : null,
      triggerEl.closest('[data-bsn-upsell-scope]'),
      triggerEl.closest('section'),
      document
    ].filter(Boolean);

    let script = null;
    for (const candidate of candidates) {
      if (!candidate) continue;
      if (candidate.matches && candidate.matches('script[data-bsn-upsell-json]')) {
        script = candidate;
        break;
      }
      if (typeof candidate.querySelector !== 'function') continue;
      script = candidate.querySelector('script[data-bsn-upsell-json]');
      if (script) break;
    }
    if (!script) return null;

    try {
      const cfg = JSON.parse(script.textContent.trim());
      if (!cfg) return null;

      if (!Array.isArray(cfg.upsells)) return null;

      const normalized = {
        headline: cfg.headline || 'Recommended add-ons',
        upsells: cfg.upsells
          .map((u) => {
            if (!u) return null;
            if (typeof u === 'string') return { handle: u.trim(), byline: '' };
            if (typeof u === 'object' && u.handle) {
              return { handle: String(u.handle).trim(), byline: String(u.byline || '') };
            }
            return null;
          })
          .filter((u) => u && u.handle)
      };

      if (!normalized.upsells.length) return null;
      return normalized;
    } catch (e) {
      return null;
    }
  }

  function applyUpsellConfigFromTrigger(triggerEl) {
    if (!triggerEl) return false;
    const cfg = readUpsellConfigFromTrigger(triggerEl);
    if (!cfg) return false;
    state.lastUpsellConfig = cfg;
    return true;
  }

  async function renderUpsells(cart) {
    if (!upsellGrid || !upsellRoot || !upsellHeadlineEl) return;
    if (state.drawerMode === 'buildsystem') {
      upsellRoot.hidden = true;
      drawer.classList.remove('has-upsells');
      return;
    }

    const cfg = state.lastUpsellConfig;
    if (!cfg || !Array.isArray(cfg.upsells) || !cfg.upsells.length) {
      upsellRoot.hidden = true;
      drawer.classList.remove('has-upsells');
      return;
    }

    const headline = cfg.headline || 'Recommended add-ons';
    upsellHeadlineEl.innerHTML = `<strong>${headline}</strong>`;

    const cartHandles = new Set((cart.items || []).map((i) => i.handle));
    // If an upsell item was removed from cart, allow adding it again.
    Array.from(state.addedUpsellHandles).forEach((handle) => {
      if (!cartHandles.has(handle)) state.addedUpsellHandles.delete(handle);
    });

    const orderedPool = cfg.upsells.slice(0, 5);
    const filtered = orderedPool.filter((u) => u && u.handle && !cartHandles.has(u.handle));
    const toShow = filtered.slice(0, 3);

    if (!toShow.length) {
      upsellRoot.hidden = true;
      drawer.classList.remove('has-upsells');
      return;
    }

    upsellRoot.hidden = false;
    drawer.classList.add('has-upsells');

    const productRows = await Promise.all(
      toShow.map(async (u) => {
        try {
          const p = await getProductJson(u.handle);
          const firstAvailable = (p.variants || []).find((v) => v.available);
          if (!firstAvailable) return null;
          return { u, p, firstAvailable };
        } catch (e) {
          return null;
        }
      })
    );

    upsellGrid.innerHTML = '';

    let renderedCount = 0;
    for (const rowData of productRows) {
      if (!rowData) continue;
      const { u, p, firstAvailable } = rowData;
      const img = p.featured_image || ((p.images && p.images[0]) ? p.images[0] : '');
      const imgSized = toSizedShopifyImage(img, 172);
      const href = `/products/${p.handle}`;
      const byline = (u.byline || '').trim();
      const price = Number(firstAvailable.price || p.price || 0);

      const card = document.createElement('div');
      card.className = 'bsn-upsell-card';
      card.dataset.handle = p.handle;

      const alreadyAddedThisSession = state.addedUpsellHandles.has(p.handle);
      if (alreadyAddedThisSession) card.classList.add('is-added');

      card.innerHTML = `
        <a class="bsn-upsell-card__img" href="${href}" aria-label="${p.title}">
          ${img ? `<img src="${imgSized || img}" alt="${p.title}" loading="lazy" decoding="async">` : ''}
        </a>

        <div class="bsn-upsell-card__content">
          <div class="bsn-upsell-card__head">
            <div class="bsn-upsell-card__head-main">
              <div class="bsn-upsell-card__title-wrap">
                <a class="bsn-upsell-card__title" href="${href}">
                  <p><strong>${p.title}</strong></p>
                </a>
              </div>
              ${byline ? `<p class="bsn-upsell-card__byline">${byline}</p>` : ''}
            </div>
            <div class="bsn-upsell-card__price-col">
              <div class="bsn-upsell-card__price-wrap">
                <div class="bsn-upsell-card__price">${formatMoney(price)}</div>
              </div>
              <div class="bsn-upsell-card__actions">
                <button type="button" class="product-form__submit button button--full-width button--secondary bsn-upsell-card__cta" ${alreadyAddedThisSession ? 'disabled' : ''}>
                  <span class="bsn-upsell-card__cta-shine" aria-hidden="true"></span>
                  <span class="bsn-upsell-card__cta-text">${alreadyAddedThisSession ? 'Added' : 'Add to cart'}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      `;

      const btn = card.querySelector('.bsn-upsell-card__cta');
      const btnText = btn.querySelector('.bsn-upsell-card__cta-text');
      card.querySelectorAll('a[href]').forEach((link) => {
        link.addEventListener('click', () => {
          if (!window.BSNMeasurement) return;
          window.BSNMeasurement.componentInteraction('pdp_drawer_upsells', 'select_product', {
            interaction_location: 'cart_drawer',
            display_mode: 'drawer',
            destination_type: 'product',
            item_id: `shopify_US_${p.id}_${firstAvailable.id}`,
            item_name: p.title
          });
        });
      });
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        const prev = btnText ? btnText.textContent : 'Add to cart';
        if (btnText) btnText.textContent = 'Adding...';
        state._openingFromAdd = true;
        let failureOperation = 'upsell_add';
        const diagnostic = { requestPath: '/cart/add.js', step: 'add_request', httpStatus: 0 };

        try {
          // Using fetch hook below will also open/refresh, but that's fine.
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-BSN-Drawer-Upsell': '1'
            },
            body: JSON.stringify({ id: firstAvailable.id, quantity: 1 })
          });

          diagnostic.httpStatus = res.status;
          diagnostic.step = 'add_response';
          if (!res.ok) {
            diagnostic.httpFailure = true;
            throw new Error('Failed to add upsell');
          }
          failureOperation = 'upsell_post_add';
          diagnostic.requestPath = '';
          diagnostic.httpStatus = 0;
          diagnostic.step = 'upsell_measurement';

          if (window.BSNMeasurement) {
            window.BSNMeasurement.componentInteraction('pdp_drawer_upsells', 'add_to_cart', {
              interaction_location: 'cart_drawer',
              display_mode: 'drawer',
              destination_type: 'cart',
              item_id: `shopify_US_${p.id}_${firstAvailable.id}`,
              item_name: p.title
            });
          }

          diagnostic.step = 'upsell_remove';
          state.addedUpsellHandles.add(p.handle);
          card.classList.add('is-added');
          card.remove();
          if (!upsellGrid.children.length) {
            upsellRoot.hidden = true;
            drawer.classList.remove('has-upsells');
          }

          // Refresh the cart and refill recommendations from the same product's upsell list.
          diagnostic.step = 'cart_refresh';
          const [cart] = await Promise.all([
            getCart(),
            hydrateBylineCacheFromLiquid()
          ]);
          diagnostic.step = 'render_cart';
          await renderCart(cart);
          diagnostic.step = 'render_upsells';
          await renderUpsells(cart);
          diagnostic.step = 'refresh_focus';
          refreshFocusables();
        } catch (e) {
          btn.disabled = false;
          if (btnText) btnText.textContent = prev || 'Add to cart';
          reportDrawerFailure(failureOperation, e, diagnostic);
        } finally {
          state._openingFromAdd = false;
        }
      });

      upsellGrid.appendChild(card);
      renderedCount += 1;
    }

    if (renderedCount === 0) {
      upsellRoot.hidden = true;
      drawer.classList.remove('has-upsells');
      return;
    }

    if (window.BSNMeasurement) {
      window.BSNMeasurement.componentView('pdp_drawer_upsells', {
        interaction_location: 'cart_drawer',
        display_mode: 'drawer',
        item_count: renderedCount
      });
    }
  }

  async function refreshDrawer(options = {}) {
    applyDrawerContextFromWindow();

    if (state.drawerMode === 'buildsystem') {
      const previewCart = buildBuildsystemPreviewCartPayload();
      await syncDrawerFromCart(previewCart, { skipUpsells: true });
      if (!options.silent) {
        setLoadingState(false);
        setStatus('');
      }
      return;
    }

    if (state.drawerMode === 'floating_callout') {
      if (itemsRoot) itemsRoot.innerHTML = '';
      if (subtotalEl) subtotalEl.textContent = formatMoney(0);
      renderBuildsystemExtras();
      refreshFocusables();
      if (!options.silent) {
        setLoadingState(false);
        setStatus('');
      }
      return;
    }

    if (state.refreshAbortController) {
      state.refreshAbortController.abort();
    }
    const controller = new AbortController();
    state.refreshAbortController = controller;
    const seq = state.refreshSeq + 1;
    state.refreshSeq = seq;

    if (!options.silent) {
      setLoadingState(true);
      setStatus('Updating cart...');
    }

    try {
      const [cart] = await Promise.all([
        getCart(controller.signal),
        hydrateBylineCacheFromLiquid(controller.signal)
      ]);
      if (controller.signal.aborted || state.refreshSeq !== seq) return;
      await syncDrawerFromCart(cart, options);
      if (!options.silent) {
        setStatus('');
      }
    } catch (e) {
      if (isAbortError(e)) return;
      setStatus('Network is slow. Please try again.', 'error');
      reportDrawerFailure('cart_refresh', e, { step: 'sync_drawer' });
      return;
    } finally {
      if (state.refreshAbortController === controller) {
        state.refreshAbortController = null;
      }
      if (state.refreshSeq === seq && !options.silent) {
        setLoadingState(false);
      }
    }
  }

  // 1) Intercept /cart/add form submits (Dawn safe)
  function interceptCartAdd() {
    document.addEventListener(
      'submit',
      async (e) => {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;

        const action = (form.getAttribute('action') || '').toLowerCase();
        if (!action.includes('/cart/add')) return;

        // Prevent Dawn redirect
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Guard so fetch hook doesn't double-open
        state._openingFromAdd = true;
        const submitter = e.submitter || form;
        state.pendingUpsellTriggerEl = submitter;
        setDefaultDrawerContext();

        const handle = form.dataset.productHandle || form.getAttribute('data-product-handle') || null;
        if (handle) state.lastAddedHandle = handle;

        if (!applyUpsellConfigFromTrigger(submitter)) {
          applyUpsellConfigFromTrigger(form);
        }

        let failureOperation = 'cart_add';
        const diagnostic = { requestPath: '', step: 'form_data', httpStatus: 0 };
        try {
          const fd = new FormData(form);

          diagnostic.requestPath = '/cart/add.js';
          diagnostic.step = 'add_request';
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: fd
          });

          diagnostic.httpStatus = res.status;
          diagnostic.step = 'add_response';
          if (!res.ok) {
            diagnostic.httpFailure = true;
            setStatus('Unable to add item. Please try again.', 'error');
            reportDrawerFailure('cart_add', null, diagnostic);
            return;
          }

          failureOperation = 'cart_post_add';
          diagnostic.requestPath = '';
          diagnostic.httpStatus = 0;
          diagnostic.step = 'open_drawer';
          openDrawer();
          diagnostic.step = 'refresh_drawer';
          await refreshDrawer();
        } catch (error) {
          setStatus('Unable to add item. Please check your connection and try again.', 'error');
          reportDrawerFailure(failureOperation, error, diagnostic);
        } finally {
          state._openingFromAdd = false;
          state.pendingUpsellTriggerEl = null;
        }
      },
      true
    );
  }

  // 2) Catch *AJAX* adds (Quick Add, cards, etc.) that call /cart/add.js directly
  function hookFetchForCartAdd() {
    const originalFetch = window.fetch;
    if (typeof originalFetch !== 'function') return;

    window.fetch = async (...args) => {
      const res = await originalFetch(...args);

      try {
        const input = args[0];
        const init = args[1] || {};
        const url =
          typeof input === 'string'
            ? input
            : (input && input.url) ? input.url : '';
        const method = String(init.method || (input && input.method) || 'GET').toUpperCase();
        const isAdd =
          url.includes('/cart/add') || url.includes('/cart/add.js');
        const isDrawerUpsellAdd = hasDrawerUpsellHeader(init);

        if (isAdd && method === 'POST' && res && res.ok) {
          if (isDrawerUpsellAdd) return res;
          if (!state.pendingUpsellTriggerEl && (!window.BSNCartDrawerContext || window.BSNCartDrawerContext.mode !== 'buildsystem')) {
            setDefaultDrawerContext();
          }
          // For non-drawer product adds, always shift upsell context to the latest product form.
          const didApply = applyUpsellConfigFromTrigger(state.pendingUpsellTriggerEl);
          if (!didApply) {
            const form = state.pendingUpsellTriggerEl && state.pendingUpsellTriggerEl.closest
              ? state.pendingUpsellTriggerEl.closest('form')
              : null;
            applyUpsellConfigFromTrigger(form);
          }
          state.pendingUpsellTriggerEl = null;
          // If submit interceptor is already doing the open, skip.
          if (!state._openingFromAdd) {
            openDrawer();
            await refreshDrawer();
          }
        }
      } catch (e) {
        // no-op
      }

      return res;
    };
  }

  if (!window.BSNCartDrawerContext || typeof window.BSNCartDrawerContext !== 'object') {
    setDefaultDrawerContext();
  } else {
    applyDrawerContextFromWindow();
  }

  interceptCartAdd();
  hookFetchForCartAdd();
  prewarmFloatingCalloutFormOnFirstScroll();


  window.BSNCartDrawer = {
  open: openDrawer,
  close: closeDrawer,
  refresh: refreshDrawer
};
})();
